export default {"src":"/_next/static/media/planet_earth.8a072303.svg","height":58,"width":58,"blurWidth":0,"blurHeight":0};